import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './css/index.css';
import { cleanupOldCache } from './services/bookCache';

// 앱 시작 시 7일 이상 된 IndexedDB 캐시 조용히 정리 (UI 블락 없음)
cleanupOldCache().catch(() => {});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
